export function AppleLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6598 15.5863C16.3573 16.285 15.9993 16.9282 15.5845 17.5196C15.0191 
        18.3257 14.5562 18.8837 14.1994 19.1936
           C13.6463 19.7022 13.0537 19.9627 12.4192 19.9775C11.9637 19.9775 11.4143 19.8479 10.7748 19.5849
           C10.1332 19.3232 9.54361 19.1936 9.00449 19.1936C8.43908 19.1936 7.83268 19.3232 7.18406 19.5849
           C6.53445 19.8479 6.01113 19.9849 5.61102 19.9985C5.00252 20.0244 4.396 19.7565 3.79059 19.1936
           C3.40418 18.8566 2.92086 18.2788 2.34187 17.4603C1.72065 16.5863 1.20993 15.5727 0.809817 14.4172
           C0.381312 13.1691 0.166504 11.9605 0.166504 10.7904C0.166504 9.45005 0.456124 8.29404 1.03623 7.3253
           C1.49214 6.54718 2.09866 5.93337 2.85778 5.48277C3.61689 5.03216 4.43711 4.80254 5.32041 4.78785
           C5.80373 4.78785 6.43754 4.93735 7.22517 5.23117C8.01057 5.52598 8.51488 5.67548 8.73598 5.67548
           C8.90129 5.67548 9.46152 5.50067 10.4112 5.15216C11.3094 4.82896 12.0674 4.69514 12.6883 4.74785
           C14.371 4.88365 15.6351 5.54696 16.4759 6.74199C14.971 7.65381 14.2265 8.93093 14.2414 10.5693
           C14.2549 11.8454 14.7179 12.9074 15.6277 13.7505C16.0401 14.1419 16.5006 14.4443 17.0129 14.6592
           C16.9018 14.9814 16.7845 15.29 16.6598 15.5863V15.5863ZM12.8007 0.400328C12.8007 
           1.40056 12.4352 2.33447 11.7069 3.19888
           C10.8279 4.22651 9.76472 4.82032 8.61179 4.72662C8.5971 4.60662 8.58858 4.48033 8.58858 4.34762
           C8.58858 3.3874 9.00659 2.35977 9.74891 1.51955C10.1195 1.09413 10.5909 0.740404 11.1624 0.458227
           C11.7328 0.18026 12.2723 0.0265378 12.7797 0.000213623C12.7945 0.133929 
           12.8007 0.267652 12.8007 0.400315V0.400328Z"
        fill="currentColor"
      />
    </svg>
  )
}
